import { Divider, Typography } from "@mui/material";
import { PhotoEvent } from 'common-models';
import { FC } from 'react';
import EventOptions from '../EventOptions';

interface EventSettingsSectionProps {
    photoEvent: PhotoEvent;
    onDisplayFreeOfChargeTextChanged: (value: boolean) => void;
    onIsExternalCopyrightChanged: (value: boolean) => void;
    onIsFreeOfChargeChanged: (value: boolean) => void;
    onIsPublicChanged: (value: boolean) => void;
}

const EventSettingsSection: FC<EventSettingsSectionProps> = ({
    photoEvent,
    onDisplayFreeOfChargeTextChanged,
    onIsExternalCopyrightChanged,
    onIsFreeOfChargeChanged,
    onIsPublicChanged
}) => {
    return (
        <>
            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" gutterBottom>
                Event Settings
            </Typography>

            <EventOptions
                photoEvent={photoEvent}
                setDisplayFreeOfChargeText={onDisplayFreeOfChargeTextChanged}
                setIsExternalCopyright={onIsExternalCopyrightChanged}
                setIsFreeOfCharge={onIsFreeOfChargeChanged}
                setIsPublic={onIsPublicChanged}
            />
        </>
    );
};

export default EventSettingsSection;
